<template>
  <v-container>
    <v-row align-content="center" justify="center">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <v-card flat> 
          <v-card-text>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search datasets..."
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="newItem()"
                ><v-icon>mdi-plus</v-icon>NEW DATASET</v-btn
              >
            </v-card-title>
            <v-data-table
              v-model="selected"
              :headers="headers"
              item-key="id_dataset"
              :search="search"
              :items="showonlyselected ? selected : getDatasets"
              :sort-by="['dataset_title']"
              ><template slot="no-data">
                <v-progress-circular indeterminate></v-progress-circular>
              </template>
              <!-- <template v-slot:item.geo.Geometry.coordinates="{ item }">
                <span>{{ parseInt(item.geo.Geometry.coordinates[2], 10) }}</span>
              </template> -->
              <!-- <template v-slot:item.pub.identifier.id="{ item }">
                <a :href="item.pub.identifier.url" target="_blank">
                  {{
                    item.pub.identifier.id.length > 30
                      ? item.pub.identifier.id.substring(0, 30) + "..."
                      : item.pub.identifier.id
                  }}
                </a>
              </template> -->
              <!-- <template v-slot:item.pub.identifier.id="{ item }">
                
                <v-btn icon small><v-icon small>mdi-open-in-new</v-icon></v-btn>
              </template> -->
              <template v-slot:item.dataset_title="{ item }">
                <span>{{
                  item.dataset_title.length > 20
                    ? item.dataset_title.slice(0, 18) + "..."
                    : item.dataset_title
                }}</span>
              </template>
              <!-- <template v-slot:item.geo.siteName="{ item }">
                <span>{{
                  item.geo.siteName.length > 20
                    ? item.geo.siteName.slice(1, 18) + "..."
                    :item.geo.siteName
                }}</span>
              </template> -->
              <template v-slot:item.archiveType="{ item }">
                <span>{{ item.archiveType }}</span>
              </template>
              <template v-slot:item.count_paleo_files="{ item }">
                <v-chip :color="getChipColor(item.count_paleo_files)">{{
                  item.count_paleo_files > 0 ? "Yes" : "No"
                }}</v-chip>
              </template>
              <template v-slot:item.count_chrono_files="{ item }">
                <v-chip :color="getChipColor(item.count_chrono_files)">{{
                  item.count_chrono_files > 0 ? "Yes" : "No"
                }}</v-chip>
              </template>
              <template v-slot:item.created_at="{ item }">
                <span>{{
                  new Date(item.created_at).toLocaleDateString()
                }}</span>
              </template>
              <template v-slot:item.updated_at="{ item }">
                <span>{{ new Date(item.updated_at).toLocaleString() }}</span>
              </template>
              <template v-slot:item.is_public="{ item }">
                <v-simple-checkbox
                  v-model="item.is_public"
                  disabled
                ></v-simple-checkbox>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon class="ma-1" @click="editItem(item)">
                  mdi-pencil
                </v-icon>

                <v-icon @click="openDeleteDialog(item.id_dataset)">
                  mdi-delete</v-icon
                >
              </template>
              <template v-slot:item.doi="{ item }">
                <v-btn
                 
                  icon
                  :to="{
                    name: 'DOIAdminView',
                    params: {
                      uuid: item.uuid,
                      fossilormodern: 'fossil',
                    },
                  }"
                >
                  <v-icon  v-if="!item.doi" class="ma-1"> mdi-plus-circle </v-icon>
                  <v-icon  v-if="item.doi" class="ma-1" :color="item.doi.is_internal? 'success' : 'warning'">
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-btn>


              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- <router-view></router-view> -->

    <v-dialog v-model="deleteDialog" width="400px">
      <v-card>
        <v-card-title> Delete Dataset </v-card-title>
        <v-card-text>
          Are you sure you want to delete this dataset? You cannot undo the
          operation.
        </v-card-text>
        <v-card-actions>
          <v-btn @click="closeDeleteDialog()">CANCEL</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="_deleteDataset()" color="error">DELETE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VueRouter from "vue-router";
const { isNavigationFailure, NavigationFailureType } = VueRouter;
export default {
  data() {
    return {
      selected: [],
      search: "",
      deleteDialog: false,
      deleteItem: null,
      showonlyselected: false,
      headers: [
        {
          text: "Title",
          align: "start",
          value: "dataset_title",
        },
        {
          text: "Archive",
          value: "archiveType",
        },
        {
          text: "Site Name",
          align: "start",
          value: "geo.siteName",
        },
        {
          text: "Country",
          align: "start",
          value: "geo.properties.location",
        },
        {
          text: "Has paleo",
          align: "right",
          value: "count_paleo_files",
        },
        {
          text: "Has chrono",
          align: "right",
          value: "count_chrono_files",
        },
        {
          text: "Date created",
          align: "right",
          value: "created_at",
        },
        {
          text: "Last update",
          align: "right",
          value: "updated_at",
        },
        /* {
          text: "Created by",
          align: "right",
          value: "created_by",
        }, */
        /* {
          text: "Is public",
          align: "end",
          value: "is_public",
        }, */
        { text: "Actions", value: "actions", align: "end", sortable: false },
        { text: "DOI", value: "doi", align: "end" },
      ],
    };
  },
  methods: {
    ...mapActions("admin_fossilpollen", [
      "fetchDatasets",
      "loadDataset",
      "loadDefaultDataset",
      "setIsEdit",
      "deleteDataset",
      "setEditDialog",
    ]),
    ...mapActions("auth", ["setIsLoading", "setLoadingMessage"]),
    openDeleteDialog(id_dataset) {
      this.deleteItem = id_dataset;
      this.deleteDialog = true;
    },
    closeDeleteDialog() {
      this.deleteItem = null;
      this.deleteDialog = false;
    },
    async _deleteDataset() {
      await this.deleteDataset(this.deleteItem);
      this.fetchDatasets();
      this.deleteDialog = false;
    },
    async editItem(item) {
      this.setIsEdit("edit");
      this.setLoadingMessage("Loading dataset information. Please wait...");
      this.setIsLoading(true);
      let result = await this.loadDataset(item.id_dataset);

      if (result) {
        this.$router
          .push("/admin-area/fossil-pollen/edit-dataset")
          .catch((failure) => {
            if (
              isNavigationFailure(failure, NavigationFailureType.redirected)
            ) {
              // show a small notification to the user
              console.log(failure);
            }
          });
      }
      this.setEditDialog(true);

      this.setIsLoading(false);
      this.setLoadingMessage("");

      /* window.dispatchEvent(new Event("resize")); */
    },
    async newItem() {
      /* await this.loadDataset(item.id_dataset); */
      this.setIsEdit("create");

      await this.loadDefaultDataset();
      this.$router
        .push("/admin-area/fossil-pollen/edit-dataset")
        .catch((failure) => {
          if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
            // show a small notification to the user
            console.log(failure);
          }
        });
    },
    getChipColor(number) {
      if (number > 0) {
        return "success";
      } else {
        return "error";
      }
    },
  },
  computed: {
    ...mapGetters("admin_fossilpollen", ["getDatasets"]),
  },
  created() {
    this.fetchDatasets();
  },
};
</script>

<style>
</style>